goog.provide("shadow.js.shim.module$date_fns$locale$en_US$default");
shadow.js.shim.module$date_fns$locale$en_US$default = esm_import$date_fns$locale$en_US.default;
